export default {
    create : {title : "🎖️ Create a new Role", send : "Create"},
    update : {title : "🎖️ Update this Role",  send : "Update"}
}